import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const selectedDashboardRoute: InvariantJiraRoute = {
	name: 'dashboard-selected',
	path: '/secure/Dashboard.jspa',
	query: ['selectPageId'],
};
